import AppDispatcher from '../dispatcher/app-dispatcher'


var UserActions = {
    updateUserToken: function (userToken) {
        AppDispatcher.handleViewAction({
            actionType: 'updateUserToken',
            userToken: userToken
        });
    }
};

export default UserActions;
